export var ETouchGesture;
(function (ETouchGesture) {
    ETouchGesture[ETouchGesture["None"] = 0] = "None";
    ETouchGesture[ETouchGesture["Touch"] = 1] = "Touch";
    ETouchGesture[ETouchGesture["Tap"] = 2] = "Tap";
    ETouchGesture[ETouchGesture["DoubleTap"] = 3] = "DoubleTap";
    ETouchGesture[ETouchGesture["ShortPress"] = 4] = "ShortPress";
    ETouchGesture[ETouchGesture["LongPress"] = 5] = "LongPress";
    ETouchGesture[ETouchGesture["LongTap"] = 6] = "LongTap";
    ETouchGesture[ETouchGesture["TwoFingerTap"] = 7] = "TwoFingerTap";
    ETouchGesture[ETouchGesture["TapCancelled"] = 8] = "TapCancelled";
    ETouchGesture[ETouchGesture["PinchBegin"] = 9] = "PinchBegin";
    ETouchGesture[ETouchGesture["PinchUpdate"] = 10] = "PinchUpdate";
    ETouchGesture[ETouchGesture["PinchEnd"] = 11] = "PinchEnd";
    ETouchGesture[ETouchGesture["FlingStart"] = 12] = "FlingStart";
    ETouchGesture[ETouchGesture["FlingCancelled"] = 13] = "FlingCancelled";
})(ETouchGesture || (ETouchGesture = {}));
